export default __webpack_public_path__ + "static/media/img48.f04eb391.jpg";